module.exports = __webpack_public_path__ + "img/image_11.ec44ed06.png";